import { currentShippingAddressStyles as styles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.headingGridItem = {
    ...styles.headingGridItem,
    css: css`
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
        justify-content: space-between;
        flex-grow: 1 !important;
        max-width: 100%;
    `,
};

styles.headingText = {
    ...styles.headingText,
    variant: "h4",
};

styles.editLink = {
    ...styles.editLink,
    typographyProps: {
        ...styles.editLink?.typographyProps,
        size: 12,
    },
};

styles.addressInfoDisplayGridItem = {
    ...styles.addressInfoDisplayGridItem,
    css: css`
        margin-top: 24px !important;
        line-height: 180%;

        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};

styles.useBillingAddress = {
    ...styles.useBillingAddress,
    button: {
        ...styles.useBillingAddress?.button,
        color: "primary",
        variant: "secondary",
    },
};
